import type {ForEachState} from 'src/reducers/for-each';


export const UPDATE_FOR_EACH = 'forEach/update';

export const RECEIVE_FOR_EACH = 'forEach/receive';

export const RESET = 'forEach/reset';

type UpdateForEachPayload = Partial<ForEachState>;

type UpdateForEachAction = {
  type: 'forEach/update';
  payload: ForEachState;
};

type ReceiveForEachAction = {
  type: 'forEach/receive';
  payload: ForEachState;
};

type ResetStateAction = {
  type: 'forEach/reset';
};

export type ForEachAction =
  | UpdateForEachAction
  | ReceiveForEachAction
  | ResetStateAction;

export const reset = (): ResetStateAction => ({type: RESET});

export const updateForEachInfo = (
  payload: UpdateForEachPayload,
): UpdateForEachAction => ({
  type: UPDATE_FOR_EACH,
  // @ts-expect-error - TS2322 - Type 'Partial<ForEachState>' is not assignable to type 'ForEachState'.
  payload,
});

export const receiveForEachInfo = (
  payload: ForEachState,
): ReceiveForEachAction => ({
  type: RECEIVE_FOR_EACH,
  payload,
});
